import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Mars(props) {
  const { nodes, materials } = useGLTF('/mars.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Baked_OG.geometry}
        material={materials.Material}
        position={[-3.932, 0, 17.539]}
        rotation={[0, -1.569, 0]}
        scale={1.528}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Rock.geometry}
        material={materials.rock_2}
        position={[1, -0.2, 1.825]}
        scale={[2,2,2]}
        rotation={[Math.PI, 0, Math.PI]}
      />
    </group>
  )
}

useGLTF.preload('/mars.glb')